import type { IconComponent } from '@consta/icons/Icon'
import type { OpenFilePickerConfigType } from '@core/core/modules'

import type {
  CrmsAttachment,
  KsuWell,
  MultipartUploadedFile,
  MultipartUploadedFileSetupType,
  SpaEventId,
  UploadedFileStatusType,
  UploadedFileStepTransitionType,
  UploadedFileStepType,
} from '../../types'

export enum EChoiceItem {
  'geoDBImport',
  'filesImport',
  'applyVelocityModel',
}

export enum EPropertiesChoiceItem {
  'param',
  'history',
  'info',
}

export type ObjectPropertiesChoiceItem = {
  disabled?: boolean
  name: string
  key: EPropertiesChoiceItem
}

export type ProjectObjectType = {
  text: string
  icon: IconComponent
  onClick: () => void
}

export type RibbonItem = {
  text: RibbonItemsText
  icon: IconComponent
  margin?: boolean
  delimiter?: boolean
  dataAnalyticsId?: SpaEventId
}

export enum RibbonItemsText {
  fileUpload = 'Загрузка файлов',
  database = 'База данных',
  snap = 'Привязка',
  mapping = 'Построение карт',
  machineLearning = 'Машинное обучение',
  calculator = 'Калькулятор',
  velocitySimulation = 'Скоростное моделирование',
  applyVelocityModel = 'Применение ГСМ',
  domainTransform = 'Преобразование домена',
  editMesh = 'Редактировать сетку',
  correlationScheme = 'Корреляционная схема',
  speedLaws = 'Скоростные законы',
  mapFetching = 'Подсадка карт',
}

export type MultipartUploadFileReturnType = {
  fileId?: string
  uploadedFile?: MultipartUploadedFile
  file?: File
}

export type UseMultipartUploadFilesReturnType = {
  uploadedFiles: MultipartUploadFileReturnType[]
  removeOpenFiles: (fileIds: string[], tasksIds?: string[]) => void
  activeUploadedFile?: MultipartUploadFileReturnType
  updateActiveFile: (fileId?: string) => void
  updateFileStep: (fileId: string, step: UploadedFileStepTransitionType) => void
  updateFileStatus: (
    fileId: string,
    step: UploadedFileStepType,
    status: UploadedFileStatusType,
  ) => void
  getFilesFromExplorer: (options?: OpenFilePickerConfigType) => Promise<void>
  updateFileConfig: (fileId: string, setupContent?: MultipartUploadedFileSetupType) => void
  addFilesToProject: (fileIds: string[]) => void
  addGeoDFiles: (files: KsuWell[]) => void
  addCrmsFiles: (files: CrmsAttachment[]) => void
}

export type FilesCardPropsType = {
  file: MultipartUploadFileReturnType
  selected: boolean
  removeCard: (id: string, taskId?: string) => void
  onMasterImportOpen: (id: string) => void
  onSelectCard: (fileId: string, checked: boolean) => void
}

export type UseFilesCardReturnType = Pick<MultipartUploadedFile, 'statuses' | 'step' | 'progress'>
